import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Address } from "../../common/_types/address";
import { User } from "../../users/_types/user";

export class Expert extends Resource {
    public override type = 'experts';

    @prop()
    @required()
    public name!: string;

    @prop()
    @required()
    public legalName!: string;

    @prop()
    public typeOfBusiness: string = 'Person';
    @prop()
    public email!: string;
    @prop()
    public phone1!: string;
    @prop()
    public phone2!: string;
    @prop()
    public phone3!: string;
    @prop()
    public active: boolean = true;
    @prop()
    @required()
    public vatNumber!: string;

    @prop()
    public bankAccountId!: string;

    @prop()
    public addressId!: string;

    @propObject(Address)
    public address: Address = new Address();


    @prop()
    public enableAccess: boolean = false;

    @prop()
    public userId!: string;

    @propObject(User)
    public user?: User;

    @prop()
    public cabinet?: string;

}